module.exports = __webpack_public_path__ + "img/Img4@2x.f9ffec39.jpg";